/*
 * The culture pipeline's tasks (routes/pipeline_tasks.py, migration 0076):
 * the stages in their order, how each status is shown, and the link that
 * opens an isolate on its Pipeline tab -- the one the emails send.
 */
import { dossierLink } from './dossierLink';

/** The server's default order (reference_data/culture_pipeline.json); an answer's own `order` wins. */
export const STAGES = ['reception', 'preservation', 'morphology', 'microscopy', 'dna'];
export const STATUSES = ['waiting', 'ready', 'in_progress', 'done', 'skipped'];
export const OPEN = ['waiting', 'ready', 'in_progress'];

/** The theme tone each status is drawn in (var(--c-<tone>-soft) / -fg). */
export const STATUS_TONE = {
  waiting: 'neutral', ready: 'info', in_progress: 'warning', done: 'success', skipped: 'neutral',
};

/** Home with this isolate open on its Pipeline tab. */
export function pipelineLink(specimenId) {
  return dossierLink(specimenId, 'pipeline');
}

/** Tasks sorted the way a person works through them: started, ready, waiting. */
export function byUrgency(tasks) {
  const rank = { in_progress: 0, ready: 1, waiting: 2 };
  return [...(tasks || [])].sort((a, b) => (rank[a.status] ?? 3) - (rank[b.status] ?? 3)
    || String(a.ready_at || '').localeCompare(String(b.ready_at || ''))
    || String(a.specimen_code || '').localeCompare(String(b.specimen_code || '')));
}
